import { render } from "./classical-header.vue?vue&type=template&id=31e2bca2&scoped=true&ts=true"
import script from "./classical-header.vue?vue&type=script&lang=ts"
export * from "./classical-header.vue?vue&type=script&lang=ts"

import "./classical-header.vue?vue&type=style&index=0&id=31e2bca2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e2bca2"]])

export default __exports__